<template>
  <div class="publicViewClass" style="padding-top:0">
      <div class="app-inner" id="paperPj">
        <div class="public-btn-small flex align-cen posta">
            <!-- <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            返回
            </div> -->
                             <div class="titBtn flex align-cen">
                <div class="btn-set stastic-exam-actions"
                @click="rebackSwich"
                >
                    返回
                  </div>
                <div class="btn-set stastic-exam-actions" @click="nextGrade(2,list.nextId)"
                   v-loading="loading2"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, .3)" 
                    v-if="nextIdBtn"
                >
                    批下一份试卷
                  </div>
                  <div class="btn-set exportExamSa"
                   @click="finshPj(1)" 
                    v-loading="loading1"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, .3)"
                    ref="btnmdsas"
                  >
                   完成批卷
                  </div>
                    </div>
            </div>
              <div class="exam-title">
              <div class="exam-title-info flex align-cen">
                <b>{{list.paperName}}</b>
                <span class="title-extra" style="padding-left:10px">
                  <span>|</span>
                  考试时间：限制{{list.timeLimit}}分钟
                </span>
              </div>
            </div>
            <div class="tabbable-custom">
                <div class="exam-analyze-ul flex align-cen">
                    <div class="exam-analyze-ul-info flex align-cen">
                        <div class="time">用时：{{convertSecondsToMinutes(list.doTime,1)}}</div>
                        <span> | </span>
                        <div class="starttime">开始答卷：{{list.startTime}}</div>
                         <span> | </span>
                          <div class="starttime">交卷：{{list.answerTime}}</div>
                    </div>
                </div>
            </div>
            <div class="rdsdiv"></div>
            <div class="tabbable-custom1">
                <div class="questions-details">
                    <div class="question result" v-for="(item,index) in questionList">
                        <div class="ques-title flex aligin-cen">
                            <div class="ques-type"> {{$util.getTopicType(item.type)}}</div>
                            <p v-html="item.title" class="qcotent"></p>
                            <div class="ques-score">
                                ({{item.questionScore}}分)
                            </div>
                        </div>
                        <div class="referAnswee">
                            <div class="grade-left">
                                参考答案：
                            </div>
                            <div class="grade-right">
                                <p v-html="item.refAnswer"></p>
                            </div>
                        </div>
                        <div class="referAnswee" style="border-bottom:solid 1px #e6e6e6;">
                            <div class="grade-left">
                                考生答案：
                            </div>
                            <div class="grade-right user-answer">
                                {{item.answerContent}}
                            </div>
                        </div>
                        <div class="commentContainer">
                            <div class="commentTip">批注：</div>
                            <el-input
                            type="textarea"
                            :rows="4"
                            placeholder="请输入批注"
                            v-model="item.notes"
                            class="comment"
                            >
                            </el-input>
                        </div>
                        <div class="form-group">
                            <div class="form-score-check">分数：</div> 
                            <div class="form-score-info-container flex align-cen">
                                 <el-input  placeholder="请输入分数" v-model="item.customerScore" clearable maxlength="3"
                                @input="numValid"
                                 class="setting-default-input"></el-input>
                                <div class="setSorce flex align-cen">
                                    <span title="点击设置分数"  
                                    v-for="(childItem,childIndex) in item.percentagesAsStrings"
                                     @click="setSorce(childItem,childIndex,index)"
                                    :class="item.currindex == childIndex ? 'setSorceCurrent' : ''"
                                     >
                                        {{childItem}}
                                    </span>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
      </div>
    </div>
</template>
<script>
import {getGrade,getGradePage,grade} from "@/api/index/index"  //获取批卷详情、批卷题目分页、批卷
export default {
    data() {
        return {
            nextIdBtn:true,
            loading1:false,
             loading2:false,
            activeClass:'-1',
            customerScore:'',
            list:{},
             currentPage: 1, //初始页
            PageSize: 1, //每页的数据
            questionList:[],
             totalCount:0,
             notes:'',
             resultQuestionVOList:[]
        }
    },
    created() {
        this.getPaperDetail()
        this.getGradePageList()
    },
    mounted () {
      console.log(this.$refs['btnmdsas'])  
    },
    methods: {
             numValid() {
                var reg = /^(1|([1-9]\d{0,1})|100)$/;
                if(reg.test(this.customerScore)==false){
                        this.customerScore = "";
                        return false;
                }else{
                    this.customerScore = this.customerScore;
                }
                },
            convertSecondsToMinutes(seconds,type){
            if(seconds >0){
               let hours = Math.floor(seconds / 3600);  
                let minutes = Math.floor((seconds % 3600) / 60);  
                let remainingSeconds = seconds % 60; 
                if(type == 1){
                 return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');  
                }else{
                    let hoursText = hours > 0 ? hours.toString().padStart(2, '0') + '时' : ''
                     return  hoursText + minutes.toString().padStart(2, '0') + '分' + remainingSeconds.toString().padStart(2, '0') + '秒';  
                }
            }else{
                return 0
            }
        },
        // 完成批卷
        finshPj(type){
            this.publicGrade(type)
        },
        // 返回
        rebackSwich(){
                   if(this.$route.query.redirect == 'moniToring'){
                  this.$router.push({
            name: "moniToring",
            query:{
                id:this.$route.query.paperId,
            }
           })
              }else{
                      this.$router.push({
            name: "examLog",
            query:{
                paperId:this.$route.query.paperId,
                practiceMode:this.$route.query.practiceMode
            }
           })
              }
        },
        // 下一份试卷
        nextGrade(type,nextId){
            this.publicGrade(type,nextId)
        },
        // 批卷公共函数
        publicGrade(type,nextId){
            let condition = true;
            this[`loading${type}`] = true
             this.resultQuestionVOList = []
            for(let i = 0; i < this.questionList.length && condition; i++){
                if(this.questionList[i].customerScore === '' ){
                    this.$util.Notifi( `请先批改第${i + 1}道试题`,'error','fa-exclamation-circle')
                    condition = false;
                    this[`loading${type}`] = false
                }
                this.resultQuestionVOList.push({
                    id:this.questionList[i].id,
                    paperQuestionId:this.questionList[i].paperQuestionId,
                    customerScore:this.questionList[i].customerScore,
                    notes:this.questionList[i].notes
                })
            }
            if(condition){
                 let params = {
            id:this.$route.query.id,
            resultQuestionVOList:this.resultQuestionVOList
           }
           grade(params)
           .then(res =>{
            this[`loading${type}`] = false
            if(res.code == 0){
                 if(type == 1){
              if(this.$route.query.redirect == 'moniToring'){
                  this.$router.push({
            name: "moniToring",
            query:{
                id:this.$route.query.paperId,
            }
           })
              }else{
                      this.$router.push({
            name: "examLog",
            query:{
                paperId:this.$route.query.paperId,
                practiceMode:this.$route.query.practiceMode
            }
           })
              }
            }else if(type == 2){
           this.currentPage = 1
            this.getPaperDetail(nextId)
            this.getGradePageList(nextId)
            }
            }else{
                this.$util.Notifi(res.msg, "error", "fa-exclamation-circle"); 
            }
           })
            }
        },
        // 设置分数
        setSorce(item,index,index1){
            this.questionList[index1].currindex = index
            this.questionList[index1].customerScore = item
        },
           handleSizeChange(val) {
       this.PageSize = val
       this.getGradePageList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.getGradePageList()
    },
        // 获取分页
        getGradePageList(nextId){
            let params = {
                resultId: nextId ? nextId : this.$route.query.id,
            }
            getGradePage(params)
            .then(res =>{
               this.questionList = res.data
                this.questionList.forEach(t =>{
                    t.percentagesAsStrings = [
                        (t.questionScore * 0),
                        (t.questionScore * 0.25),
                        (t.questionScore * 0.5),
                        (t.questionScore * 0.75),
                        (t.questionScore * 1),
                    ]
                    t.customerScore = ''
                    t.currindex = '-1'
                })
            })
        },
        // 获取试卷详情
          getPaperDetail(nextId){
            getGrade({id:nextId ? nextId : this.$route.query.id},'get')
            .then(res =>{
              this.list = res.data
              if(!this.list.nextId){
                this.nextIdBtn = false
              }
            })
            .catch(err =>{})
        },
        // 返回监控页面
        reback(){
             this.$router.push({
            name: "moniToring",
            query:{
                id:this.$route.query.paperId,
            }
           })
        },
    }
}
</script>
<style lang="scss" scoped>
#paperPj{
   .titBtn{
      .btn-set{
        min-width: 120px;
        margin-right: 16px;
        cursor: pointer;
        color: #409eff;
        border: 1px solid #409eff;
        padding: 7px 10px;
        border-radius: 4px!important;
        text-align: center;
      }
      .exportExamSa{
        border: none;
        background: #409eff;
        color: #fff;
      }
    }
     .exam-title{
    position: relative;
    padding: 0 24px;
    height: 40px;
    line-height: 40px;
    background-color: #ffffff;
    border-bottom: solid 1px #e6e6e6;
    border-radius: 10px 10px 0 0;
    font-size: 20px;
    color: #333333;
    font-weight: 600;
    cursor: default;
    b{
      font-weight: bolder;
    }
    .title-extra{
      font-size: 14px;
      font-weight: normal;
      color: #999;
    }
  }
   .tabbable-custom{
    background-color: #f3f4f8;
    position: relative;
       .exam-analyze-ul{
     padding: 20px 24px 20px;
    border-radius: 0 0 10px 10px!important;
    background-color: #fff;
    .exam-analyze-ul-info{
        font-size: 14px;
        span{
            padding: 0 10px;
        }
    }
    }
    }
    .rdsdiv{
        height: 20px;
    background: #f7f8fa;
    width: calc(100% + 32px);
    margin-left: -16px;
    }
    .tabbable-custom1{
     background: #fff;
    padding: 16px;
    border-radius: 5px;
    .questions-details{
        margin-top: 24px;
        .question{
            margin: 0 0 30px 0;
            box-shadow: 0 0 0;
            background: #fafafa;
            border-radius: 10px;
            border: 1px solid #E6E6E6;
            padding-top: 14px;
            .ques-title {
                .ques-type{
                    background-color: #eb0000;
                    font-size: 12px;
                   color: #fff;
                   padding: 0 12px;
                   border-radius: 4px;
                   margin-right: 5px;
                }
                .qcotent{
                    font-size: 14px;
                }
                .ques-score{
                    font-size: 14px;
                    color: #aeaeae;
                }
            }
            .referAnswee{
                color: #666;
                font-size: 14px;
                .grade-left{
                    color: #999;
                     width: 76px;
                }
                .grade-right{
                    margin: 10px 0 0 0;
                    width: 100%;
                }
                .user-answer{
                    position: relative;
                    height: auto;
                    padding-top: 20px;
                    padding-bottom: 20px;
                    margin: 0;
                }
            }
            .commentContainer{
                padding: 0 24px;
                .commentTip{
                    font-size: 14px;
                    color: #333;
                    margin-bottom: 12px;
                }
                .comment {
                    .el-textarea__inner{
                height: 74px;
                width: 100%;
                border-radius: 4px !important;
                border: 1px solid #e2e2e2;
                padding: 10px 20px;
                transition: all 0.5s ease;
                    }
                }
            }
            .form-group{
                margin: 24px 24px 10px;
                .form-score-check{
                    font-size: 16px;
                    color: #333;
                }
                .form-score-info-container{
                    margin-top: 10px;
                }
                .setSorce{
                    span{
                     background-color: #82cbff;
                    border-radius: 4px !important;
                    padding: 4px 14px;
                    font-size: 14px;
                    cursor: pointer;
                    margin-right: 16px;
                    color: #fff;
                    }
                    .setSorceCurrent{
                        background-color: #36aafd !important;
                    }
                }
            }
            .fentotl{
                margin-bottom: 10px;
                margin-right: 10px;
            }
            .ques-title,.referAnswee,.eassy_grading_answer{
                margin: 0 24px 24px;
            }
        }
    }
    }
}
::v-deep{
    .el-loading-spinner{
        margin-top: -13px !important;
    }
    .setting-default-input{
     width: 100px;
    padding-left: 3px;
    margin-right: 20px;
    .el-input__inner{
        width: 100px!important;
        height: 32px!important;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #e6e6e6;
        
    }
    .el-input__icon{
        line-height: 32px !important;
    }
}
}
</style>